<template>
  <div>
    <label class="bk-form-label">
      {{ label }}
    </label>
    <textarea
      v-model="value"
      class="bk-form-input"
      :placeholder="placeholder"
      :required
      :disabled
      rows="5"
    />
    <div v-if="description" class="bk-form-description">{{ description }}</div>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  description: { type: String, required: false },
  placeholder: { type: String, required: false },
  required: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false }
});
const value = defineModel({ type: String });
</script>
